import baseService from './base';

// EG-26 — camada HTTP do módulo de Cronogramas (painel interno GPESG).

export const listSchedules = (params = {}) =>
 baseService.get('/schedule', { params }).then((r) => r.data);

export const getSchedule = (id) =>
 baseService.get(`/schedule/${id}`).then((r) => r.data);

export const createSchedule = (payload) =>
 baseService.post('/schedule', payload).then((r) => r.data);

export const updateSchedule = (id, payload) =>
 baseService.patch(`/schedule/${id}`, payload).then((r) => r.data);

export const deleteSchedule = (id) =>
 baseService.delete(`/schedule/${id}`).then((r) => r.data);

export const createActivity = (idSchedule, payload) =>
 baseService.post(`/schedule/${idSchedule}/activity`, payload).then((r) => r.data);

export const updateActivity = (idActivity, payload) =>
 baseService.patch(`/schedule/activity/${idActivity}`, payload).then((r) => r.data);

export const deleteActivity = (idActivity) =>
 baseService.delete(`/schedule/activity/${idActivity}`).then((r) => r.data);

export const listAttachments = (idActivity) =>
 baseService.get(`/schedule/activity/${idActivity}/attachment`).then((r) => r.data);

export const addAttachment = (idActivity, payload) =>
 baseService.post(`/schedule/activity/${idActivity}/attachment`, payload).then((r) => r.data);

export const deleteAttachment = (idAttachment) =>
 baseService.delete(`/schedule/activity/attachment/${idAttachment}`).then((r) => r.data);

export const getConsultantCandidates = (idCompany) =>
 baseService
  .get('/schedule/consultant-candidates', { params: { id_company: idCompany } })
  .then((r) => r.data);

export const getResponsibleCandidates = (idCompany) =>
 baseService
  .get('/schedule/responsible-candidates', { params: { id_company: idCompany } })
  .then((r) => r.data);

export const listCompanies = () =>
 baseService.get('/company').then((r) => r.data);
